import type { RevalidateTrigger } from 'data/FHIRFetcher';
import type { Task } from 'fhir/r4';
import React, { useState } from 'react';
import type { PropsWithChildren } from 'react';

import AddTask from './addTask';
import AssignTask from './assignTask';
import { TaskButtonWrapper, TaskHeaderContainer, TaskHeaderTitle, TitleWrapper } from './taskHeader.styles';
import type { DefaultOptionType, FlatPractitionerSelectOption, ReferralIdOption } from './types';


type TaskHeaderProps = {
  disableMultiSelect?: boolean | undefined;
  flatPractitioners: FlatPractitionerSelectOption[];
  foodVendors: DefaultOptionType[];
  handleNewTask: (taskId: string) => void;
  isActivity?: boolean | undefined;
  /** Absent on the activity tabs, which are not scoped to one organization. */
  orgCode?: string | undefined;
  patientId?: string | undefined;
  practitionerList: DefaultOptionType[];
  referralIdList: ReferralIdOption[];
  render: boolean;
  selectedTasks: Task[];
  setRender: (value: boolean) => void;
  setRenderUrl: (value: boolean) => void;
  setSelectedTasks: (tasks: Task[]) => void;
  /** Optional to match the `= 0` default below; the caller passes `taskList?.length`. */
  taskCount?: number | undefined;
  tasksMutate: RevalidateTrigger;
  selectedCareplanTasks: boolean;
};

const TaskHeader: React.FC<PropsWithChildren<TaskHeaderProps>> = ({
  children,
  disableMultiSelect,
  flatPractitioners,
  foodVendors,
  handleNewTask,
  isActivity,
  orgCode,
  patientId,
  practitionerList,
  referralIdList,
  render,
  selectedTasks,
  setRender,
  setRenderUrl,
  setSelectedTasks,
  taskCount = 0,
  tasksMutate,
  selectedCareplanTasks,
}) => {
  const [isAddTaskOpen, setIsAddTaskOpen] = useState(false);

  const handleAddTaskToggle = (value: boolean) => {
    setIsAddTaskOpen(value);
  };

  return (
    <TaskHeaderContainer>
      <TitleWrapper>
        <TaskHeaderTitle>Tasks ({taskCount})</TaskHeaderTitle>
        <TaskButtonWrapper>
          {/* The children is the filter component */}
          {children}
          {!isActivity && (
            <AddTask
              flatPractitioners={flatPractitioners}
              foodVendors={foodVendors}
              handleAddTaskToggle={handleAddTaskToggle}
              handleNewTask={handleNewTask}
              isAddTaskOpen={isAddTaskOpen}
              orgCode={orgCode}
              patientId={patientId}
              referralIdList={referralIdList}
              setRenderURL={setRenderUrl}
            />
          )}
        </TaskButtonWrapper>
      </TitleWrapper>
      <AssignTask
        disableMultiSelect={disableMultiSelect}
        flatPractitioners={flatPractitioners}
        foodVendors={foodVendors}
        orgCode={orgCode}
        practitionerList={practitionerList}
        render={render}
        selectedTasks={selectedTasks}
        setRender={setRender}
        setSelectedTasks={setSelectedTasks}
        tasksMutate={tasksMutate}
        selectedCareplanTasks={selectedCareplanTasks}
      />
    </TaskHeaderContainer>
  );
};

export default TaskHeader;
